import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Button from '../../../../Form/Button'
import Select from 'react-select'

let options = []
for (let i = 0; i <= 24; i++) {
  for (let minute of ['00', '30']) {
    if (i === 24 && minute === '30') {
      continue
    }
    const hour = i > 9 ? i : '0' + i
    let option = Object.freeze({
      value: hour + ':' + minute,
      label: hour + ':' + minute,
      hour: parseInt(hour),
      minute: parseInt(minute)
    })
    options.push(option)
  }
}

class AttributeHoursAdder extends PureComponent {

  state = {
    from: null,
    to: null,
  }

  onChangeFrom = (option) => {
    this.setState({ from: option })
  }
  onChangeTo = (option) => {
    this.setState({ to: option })
  }

  onAddClick = () => {
    if (this.state.from === null || this.state.to === null) {
      return
    }
    const from = this.state.from.value
    const to = this.state.to.value
    this.setState({ from: null, to: null })
    this.props.onAdd([from, to])
  }

  isOptionDisabledFrom = (option) => {
    if (this.state.to === null) {
      return false
    }
    if (option.hour > this.state.to.hour || (option.hour === this.state.to.hour && option.minute >= this.state.to.minute)) {
      return true
    }
    return false
  }

  isOptionDisabledTo = (option) => {
    if (this.state.from === null) {
      return false
    }
    if (option.hour < this.state.from.hour || (option.hour === this.state.from.hour && option.minute <= this.state.from.minute)) {
      return true
    }
    return false
  }

  render () {
    const { t } = this.props

    return (
      <div className={'attribute-hours-adder'}>
        <div className={'time-box-container'}>
          <div className={'time-box'}>
            <Select options={options} placeholder={t('FROM')} className={'time-box-select'}
                    value={this.state.from}
                    onChange={this.onChangeFrom}
                    isOptionDisabled={this.isOptionDisabledFrom}
                    isClearable={true}/>
          </div>
          <div className={'time-box'}>
            <Select options={options} placeholder={t('TO')} className={'time-box-select'}
                    value={this.state.to}
                    onChange={this.onChangeTo}
                    isOptionDisabled={this.isOptionDisabledTo}
                    isClearable={true}/>
          </div>
        </div>
        <div>
          <Button classNames={'Button-Full'} onClick={this.onAddClick}
                  disabled={this.state.from === null || this.state.to === null || this.props.addDisabled}>{t('ADD')}</Button>
        </div>
      </div>
    )
  }
}

AttributeHoursAdder.defaultProps = {}
AttributeHoursAdder.propTypes = {
  onAdd: PropTypes.func.isRequired,
  addDisabled: PropTypes.bool.isRequired
}
export default withTranslation()(AttributeHoursAdder)
